__turbopack_context__.v({
  "sideTitle": "_3kV-Ta_sideTitle",
  "sideViewMain": "_3kV-Ta_sideViewMain",
  "sideViewMainNotInDetail": "_3kV-Ta_sideViewMainNotInDetail",
  "sideViewSidebar": "_3kV-Ta_sideViewSidebar",
  "sideViewSidebarInDetail": "_3kV-Ta_sideViewSidebarInDetail",
  "sideViewWrapper": "_3kV-Ta_sideViewWrapper",
});
